//=====================================================
//　API関連処理
//=====================================================
import axios from 'axios';

export function getApiData(url:string, params:{}, callback:any) {
    axios.get(process.env.REACT_APP_APIURLBASE + url, params)
    .then(function(res){
        callback(res);
    })
    .catch(function(error){
        catchError(error,"GET",callback);
    });
}

export function getApiDataWithToken(url:string, params:{}, token:string|null, callback:any){
    const apiUrl = process.env.REACT_APP_APIURLBASE + url;
    const httpClinet = axios.create({
        headers: {
            'Authorization': "Bearer " + token
        }
    });

    httpClinet.get(apiUrl, params)
    .then(function(res){
        callback(res);
    })
    .catch(function(error){
        catchError(error,"GET",callback);
    });
}

export function postApiData(url:string, params:{}, callback:any){
    const apiUrl = process.env.REACT_APP_APIURLBASE + url;
    axios.post(apiUrl, params)
    .then(function(res){
        callback(res);
    })
    .catch(function(error){
        catchError(error,"POST",callback);
    });
}

export function postApiDataWithToken(url:string, params:{}, token:string|null, callback:any) {
    const apiUrl = process.env.REACT_APP_APIURLBASE + url;
    const httpClinet = axios.create({
        headers: {
            'Authorization': "Bearer " + token
        }
    });

    httpClinet.post(apiUrl, params)
    .then(function(res){
        callback(res);
    })
    .catch(function(error){
        catchError(error,"POST",callback);
    });
}

export function putApiDataWithToken(url:string, params:{}, token:string|null, callback:any) {
    const apiUrl = process.env.REACT_APP_APIURLBASE + url;
    const httpClinet = axios.create({
        headers: {
            'Authorization': "Bearer " + token
        }
    });

    httpClinet.put(apiUrl, params)
    .then(function(res){
        callback(res);
    })
    .catch(function(error){
        catchError(error,"PUT",callback);
    });
}

export function delApiDataWithToken(url:string, params:{}, token:string|null, callback:any) {
    const apiUrl = process.env.REACT_APP_APIURLBASE + url;
    const httpClinet = axios.create({
        headers: {
            'Authorization': "Bearer " + token
        }
    });

    httpClinet.delete(apiUrl, params)
    .then(function(res){
        callback(res);
    })
    .catch(function(error){
        catchError(error,"DELETE",callback);
    });
}

function catchError(error:any,methodName : string,  callback:any ){
    if (error.response) {
        // リクエストが行われ、サーバーがステータスコードで応答しました
        // 2xxの範囲外です
        console.log(methodName + " API Error response");
        callback(error.response);
    } else if (error.request) {
        // リクエストは送信されましたが、応答がありませんでした
        // `error.request`は、ブラウザ内のXMLHttpRequestのインスタンス
        console.log(methodName + " API Error request");
        console.log(error.request);
        callback(error.request);
    } else {
        // エラーをトリガーしたリクエストの設定中に何かが発生しました
        console.log(methodName + " API Error");
        console.log('Error', error.message);
        callback(error);
    }
}